import { ComponentProps, useMemo } from "react"

import { twMerge } from "tailwind-merge"

import { useFieldContext } from "./FieldProvider"
import { PathBuilder } from "~/src/lib/iname"
import { dataFlag } from "~/src/lib/jsx"

export type InputProps = { name?: PathBuilder | string; errored?: boolean } & Omit<ComponentProps<"input">, "name">

/**
 * A Beekit skin of the native input element that forwards its ref.
 */
export function Input(props: InputProps) {
  const { name: name_, id: id_, errored: errored_, className, onChange, ...restProps } = props

  const fieldContext = useFieldContext()
  const id = useMemo(() => id_ ?? fieldContext?.inputId, [id_, fieldContext?.inputId])
  const name = useMemo(() => name_?.toString() ?? fieldContext?.name, [name_, fieldContext?.name])
  const errored = useMemo(() => errored_ ?? fieldContext?.hasErrors, [errored_, fieldContext?.hasErrors])

  return (
    <input
      id={id}
      name={name?.toString()}
      onChange={(event) => {
        fieldContext?.descendentChange?.()
        onChange?.(event)
      }}
      className={twMerge(
        "rounded-lg border border-gray-300 disabled:cursor-not-allowed disabled:bg-gray-100",
        "data-errored:border-red-600 data-errored:focus:ring-red-600",
        className
      )}
      {...dataFlag(errored, "errored")}
      {...restProps}
    />
  )
}
